import type { IExercise } from '../exercises';

export const FOUR_WAY_EPISODE_03_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-four-way-03-01",
    "name": "侧弓步动态拉伸",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "general",
    "tips": ["核心收紧，控制动作节奏", "全程保持稳定"],
    "sets": 2,
    "reps": "每侧10",
    "rpe": 3,
    "restSeconds": 20,
    "isBodyweight": true,
    "isStretch": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["目标拉伸肌群"],
    "demoUrl": "/media/collections-20261008/demos/reviewed-07ab841d30a76776c64ba3dd.mp4",
    "videoUrl": "/media/collections-20261008/videos/9231624191f452b429ece3f0.mp4",
    "source": "四分化训练 · 第3期",
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-03-02",
    "name": "仰卧髋内收器械",
    "bodyPart": "warmup",
    "equipment": "machine",
    "subCategory": "hip-leg",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["髋内收肌群"],
    "demoUrl": "/media/collections-20261008/demos/mobile-36822ab79d40d5a95d19745a.mp4",
    "videoUrl": "/media/collections-20261008/videos/c6cf4637b020dd5bef6b32ff.mp4",
    "source": "四分化训练 · 第3期",
    "isWarmup": true,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-03-03",
    "name": "侧卧髋内收",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "hip-leg",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "每侧12",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["髋内收肌群"],
    "demoUrl": "/media/collections-20261008/demos/mobile-f69de79b1c7c8bcb412c6374.mp4",
    "videoUrl": "/media/collections-20261008/videos/1488b94724940331d882a583.mp4",
    "source": "四分化训练 · 第3期",
    "isWarmup": true,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-03-04",
    "name": "保加利亚分腿蹲",
    "bodyPart": "legs",
    "equipment": "dumbbell",
    "subCategory": "glutes",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "每侧8-10",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["臀大肌", "腘绳肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-9025e7e940354452c3277606.mp4",
    "videoUrl": "/media/collections-20261008/videos/bb2540878ed8f2fe2c56effd.mp4",
    "source": "四分化训练 · 第3期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-03-05",
    "name": "哑铃弓步蹲",
    "bodyPart": "legs",
    "equipment": "dumbbell",
    "subCategory": "quadriceps",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "每侧10",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["股四头肌", "臀大肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-841f33d6d81ce6e88826e49f.mp4",
    "videoUrl": "/media/collections-20261008/videos/9ee9ff722e351b9f12f92252.mp4",
    "source": "四分化训练 · 第3期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-03-06",
    "name": "单腿哑铃硬拉",
    "bodyPart": "legs",
    "equipment": "dumbbell",
    "subCategory": "hamstrings",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "每侧10",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["腘绳肌", "臀大肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-12c4ef36f3aa97949dcfa7f4.mp4",
    "videoUrl": "/media/collections-20261008/videos/5b9f5d3e71d3b6ce237bc062.mp4",
    "source": "四分化训练 · 第3期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-03-07",
    "name": "站姿提踵",
    "bodyPart": "legs",
    "equipment": "bodyweight",
    "subCategory": "calves",
    "tips": ["核心收紧，控制动作节奏", "全程保持稳定"],
    "sets": 4,
    "reps": "15-20",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["腓肠肌", "比目鱼肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-dc7d2a0f813af9f388680757.mp4",
    "videoUrl": "/media/collections-20261008/videos/b85de07b801f6e1013e7f7eb.mp4",
    "source": "四分化训练 · 第3期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
